import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Link,
  TextField,
} from "@mui/material";
import CookieJs from "js-cookie";
import get from "lodash/get";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Controller, useForm } from "react-hook-form";
import { Link as RouterLink } from "react-router-dom";
import * as yup from "yup";
import Logo from "../assets/images/dekostel.jpg";
import TextFieldPassword from "../components/PasswordTextField";
import useAutomaticLogIn from "../hooks/useAutomaticLogIn";
import { useAppDispatch } from "../hooks/useDispatch";
import useNotification from "../hooks/useNotification";
import service from "../services/auth";
import { actions } from "../store/reducers/global";

export default function SignInPage() {
  const notification = useNotification();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  useAutomaticLogIn();

  const schema = yup.object({
    username: yup.string().required(),
    password: yup.string().required(),
  });

  const form = useForm({
    defaultValues: {
      username: "",
      password: "",
      remember: true,
    },
    resolver: yupResolver(schema),
  });

  const onSubmit = (values: any) => {
    setIsLoading(true);
    service
      .signIn(values)
      .then((data) => {
        const isActive = get(data, "profile.is_active", false);
        if (isActive) {
          dispatch(actions.signIn(get(data, "profile")));
          CookieJs.set("ID_USER_ACCOUNT", get(data, "access_token"), {
            expires: 0.5,
          });
          CookieJs.set("ID_USER", get(data, "data.id"), { expires: 0.5 });
          window.location.href = '/';
        } else {
          notification.onOpen({
            message: "sorry, your account has been deactivated",
            type: "error",
            position: "top",
          });
        }
      })
      .catch((error) => {
        notification.onOpen({
          message: error?.response?.data?.error || "Something went wrong",
          type: "error",
          position: "top",
        });
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Helmet>
        <title>Sign In</title>
      </Helmet>

      <Box sx={{ width: 300 }}>
        <Box sx={{ textAlign: "center" }}>
          <img src={Logo} style={{ height: 90 }} alt="signin" />
        </Box>

        <Box
          component="form"
          onSubmit={form.handleSubmit(onSubmit)}
          sx={{ mt: 3 }}
        >
          <FormControl fullWidth>
            <FormLabel required>Username</FormLabel>
            <Controller
              name="username"
              control={form.control}
              render={({ field: { ref, ...field }, fieldState }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  error={Boolean(fieldState?.error)}
                  helperText={fieldState.error?.message}
                  {...field}
                  inputRef={ref}
                />
              )}
            />
          </FormControl>

          <FormControl fullWidth sx={{ mt: 2 }}>
            <FormLabel required>Password</FormLabel>
            <Controller
              name="password"
              control={form.control}
              render={({ field: { ref, ...field }, fieldState }) => (
                <TextFieldPassword
                  size="small"
                  variant="outlined"
                  error={Boolean(fieldState?.error)}
                  helperText={fieldState.error?.message}
                  {...field}
                  inputRef={ref}
                />
              )}
            />
          </FormControl>

          <Box sx={{ mt: 2 }}>
            <Link
              component={RouterLink}
              to="/forgot-password"
              fontWeight="700"
              underline="none"
            >
              Forgot Password?
            </Link>
          </Box>

          <FormControl sx={{ mt: 1 }}>
            <Controller
              name="remember"
              control={form.control}
              render={({ field }) => (
                <FormControlLabel
                  {...field}
                  control={<Checkbox />}
                  label="Remember me"
                />
              )}
            />
          </FormControl>

          <LoadingButton
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            sx={{ mt: 1 }}
            loading={isLoading}
          >
            SIGN IN
          </LoadingButton>
        </Box>
      </Box>
    </Box>
  );
}
